import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { TypographyProps } from "@mui/material/Typography";

interface ListGridExpandedSectionProps {
  title: string;
  slotProps?: {
    title?: TypographyProps;
  };
  isEmpty?: boolean;
  emptyText?: string;
  children?: ReactNode;
}

/**
 * One section of an expanded ListGrid row: a small upper-case title over its
 * content, or the empty message. `slotProps.title` takes the title's
 * Typography props (its `sx` is added on top).
 */
export const ListGridExpandedSection = (props: ListGridExpandedSectionProps) => {
  const { title, slotProps, isEmpty, emptyText, children } = props;
  const titleProps = slotProps?.title ?? {};
  const titleSx = titleProps.sx;

  return (
    <Box
      component="section"
      sx={{ minWidth: 0 }}
    >
      <Typography
        color="text.secondary"
        component="h3"
        variant="caption"
        {...titleProps}
        sx={[
          {
            display: "block",
            fontWeight: 600,
            letterSpacing: "0.06em",
            mb: 1,
            textTransform: "uppercase",
          },
          ...(Array.isArray(titleSx) ? titleSx : [titleSx]),
        ]}
      >
        {title}
      </Typography>
      {isEmpty && emptyText && (
        <Typography
          color="text.secondary"
          variant="body2"
        >
          {emptyText}
        </Typography>
      )}
      {children}
    </Box>
  );
};
